var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailIconRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "49px",
    viewBox: "0 0 49 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medium-Copy-6",
    transform: "translate(-392, -407)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(392, 407)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-Copy-2",
    fill: "#FFE1E3",
    cx: 24.5,
    cy: 24.5,
    r: 24.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,16.5752035 C12.1174862,16.2581923 12.2960706,15.9670751 12.529864,15.7228511 C12.9704298,15.259034 13.568448,15 14.1911292,15 L35.8088708,15 C36.431552,15 37.0295702,15.2590372 37.470136,15.7228511 C37.7039354,15.9683193 37.8836928,16.2594239 38,16.576435 L25.2609468,25.9364588 C25.1176125,26.0203393 24.9472452,26.0203393 24.807448,25.9413931 C24.8003988,25.9376925 14.5368025,18.4305749 12,16.5753696 L12,16.5752035 Z M38,19.0044762 L38,31.6686296 C38,32.286439 37.7468758,32.8797784 37.2936491,33.3168973 C36.8416537,33.7552098 36.2281211,34 35.5892857,34 L13.4107143,34 C12.7718789,34 12.1583463,33.7552069 11.7063509,33.3168973 C11.2531211,32.8797784 11,32.286439 11,31.6686296 L11,19 L23.2209714,27.2344749 C23.236641,27.244966 23.2523099,27.2542915 23.2679792,27.263617 C24.0442215,27.7252358 25.0229792,27.724072 25.7980181,27.2601199 C25.8136876,27.2507944 25.8281522,27.2414689 25.8438224,27.2321434 L38,19.0044762 Z",
    id: "Shape",
    fill: "#8B131C",
    fillRule: "nonzero"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIconRed);
export default __webpack_public_path__ + "static/media/email-icon--red.4629f1f94ad4c4b5d63d5c409a38c266.svg";
export { ForwardRef as ReactComponent };